import { useEffect, useState } from 'react';
import { serverNow } from '@/lib/api';

/** Server time, refreshed every `stepMs` (pass null to stop ticking). */
export function useServerNow(stepMs: number | null): number {
  const [now, setNow] = useState(() => serverNow());
  useEffect(() => {
    if (stepMs === null) return;
    setNow(serverNow());
    const id = window.setInterval(() => setNow(serverNow()), stepMs);
    return () => window.clearInterval(id);
  }, [stepMs]);
  return now;
}

/**
 * True from `leadMs` before a server moment (the deadline) onwards, re-rendering exactly then: an answer that is
 * still not locked in can say "lock in before the buzzer" in the last seconds.
 */
export function useNearing(at: number | undefined, leadMs = 5000, active = true): boolean {
  const calc = () => active && typeof at === 'number' && serverNow() >= at - leadMs;
  const [near, setNear] = useState(calc);
  useEffect(() => {
    setNear(calc());
    if (!active || typeof at !== 'number') return;
    const wait = at - leadMs - serverNow();
    if (wait <= 0) return;
    const id = window.setTimeout(() => setNear(calc()), wait + 20);
    return () => window.clearTimeout(id);
    // calc reads the same three values
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [at, leadMs, active]);
  return near;
}
